import React from 'react'
import DigiDocImage from '../Assets/Images/DigiDoc Head.png';
import SplashImage from '../Assets/Images/Online Doctor-amico.png';
import Otp from '../Components/OtpForm/Otp';

const OtpView = () => {
  return (
    
   
    <div>
    {/* <div className="language-container">
    <header className="logo-section">
      <img src={DigiDocImage} alt="DigiDoc" className="logo" />
    </header>
    <div className="illustration-section">
      <img src={SplashImage} alt="Doctor Illustration" className="illustration" />
    </div> */}
    <Otp/>
  {/* </div> */}
  </div>
  )
}

export default OtpView